import React from 'react';
import RevenueRangeComponent from '@intelligence/components/RevenueRange';
import NumberRangePreview from '../shared/NumberRangePreview';
import { getNumberRangeValue } from '../shared/valueUtils';
import { FILTER_TYPE } from '../filterTypes';

import type { IFilterRenderProps, IFilterTypeEntry } from '@intelligence/v3/filterCore/registry';
import type { IFilterControlModule } from '../controlModule';
import type { IRevenueRangeFilterValue } from './types';

const RevenueRangeRenderer: React.FC<IFilterRenderProps<IRevenueRangeFilterValue>> = (props) => {
  const { field, label = '', title, value, onChange, clickSetDefault = false, ...rest } = props;

  return (
    <RevenueRangeComponent
      {...rest}
      key={field}
      title={title || label || 'dbi_revenue_range'}
      clickSetDefault={clickSetDefault}
      value={getNumberRangeValue(value)}
      onChange={(payload: any) => {
        onChange(payload);
      }}
    />
  );
};

const getRenderPreview = (): NonNullable<IFilterTypeEntry['renderPreview']> => {
  // eslint-disable-next-line react/display-name
  return (item, value) => <NumberRangePreview item={item} valueItem={value} />;
};

export const revenueRangeControl: IFilterControlModule = {
  type: FILTER_TYPE.REVENUE_RANGE,
  entry: {
    render: (props) => {
      return <RevenueRangeRenderer {...props} />;
    },
  },
  getRenderPreview,
};
